import tinymce from "tinymce"
tinymce.PluginManager.add("watermark", function(editor, url) {
  let pluginName = "水印"
  var openDialog = function() {
    return editor.fire("watermark")
  }

  editor.ui.registry.getAll().icons["watermark"] ||
    editor.ui.registry.addIcon(
      "watermark",
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">  <image id="image0" width="20" height="20" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABv1BMVEUAAAAAAAArK1UjNT4f Lj4iLzwmL0JAQEAiLz8jLz4lMEEAVVUzMzMiMEEiLz4iLz4jLz4jLz0hLj8iMD8iMD8kL0ErKysj MD4mLTwiLz8iLz8jMD8lL0IAAFUcOTkgIEAgQEAaMzMjLjojLz4iMD4mMUEjMD4jMUEnOzsjLz8j MD4eLTwkSUkkMT8jMD8iMD0iLz4kLz4kLkAjLz4jMD4iMT4hLj4oNUIwN0UhLz0iLz8iLz8kMD0h Lj4hMT4fLj4AAIAzM2YiMD4iMD0gMkAjMD8pM0chMEAhMUIjLjwiMD4iLz8iLj4hLj4hLz4hLz4h Lj4iLz4jMD8iLz0hLz0iLz4jMD0iLz8iLj4jMD4jMD4jLT8jMkEhL0AmM0AmNUQiL0ApMUIhMD8g Lz4iMT8iLj8jMkAjLD5VVVUiLz8hLj4iLz4iLz4iLz0jLj8dMTsiLz4iLz8jMT8iKzxAQEAiMT0h MD8XLkYrQEAhMUAjMD0hLj8iLz8iLz4iMD8lMEAAAAAnMUUkMkEoNkgnNkgnNkclM0MkMUEkMUAj Lz8jMD8kMkIlMkMmNEUpOEkpOEojMUEjMUIoN0kiLz/////ty55bAAAAgnRSTlMAAQYdISYbCI3r WgMFWrR4fH16htxiBnsiw9DcYQMJCAgKFs7BL9VeDeTEEQeiv8zvMRyXsbKEOiW32M9PXnNjAgVa SzhmGWsfSErC4+j09eXmru7x3tzg8+ypSTNzFCJ4H1VnWWlIHQOf1tXX2Ioa89lJHgRpRQsMVGBN fsk1bwIa1KFflQAAAAFiS0dElH9nShUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfnBw0N ASpNp+6TAAABJklEQVQY02NgYGRgYmaBAFY2BkZGBiBgZGDnaGpuaQaC1jZOLgZukCAPA287H7+A gICgkLBIR6coWFSMQbxVggECJKWku2QYZEGCAi0sDHLyCooMSsoqqmpd6kBRoGAzm4Zmd7eWto5u j55+h4EhWGWzEY8xn4mpmbmFpZW1Va8NRJAFZKCtnb0Dg5GjU58zQtDF1c3dA0h79ntBBNnkvH18 /TT9AwKDGLzggop6wSGhYeERkVEM0TBBoPaY2DiG+IREBoRKCQbGpOSUFKfUNAYGZ5hgekZmVnZO bk52dh5CZb52wYQuEJhYyFAEEywuKS1TUCxXrKisglkk3hrPgADVk7xgQVcjKAACNYJCtZPrUAK5 ubmlpbWrvgEc9PDoAIFGBwZGAFyaTzN8W5uaAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIzLTA3LTEz VDExOjAxOjQyKzAyOjAwxzO73QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMy0wNy0xM1QxMTowMTo0 MiswMjowMLZuA2EAAAAASUVORK5CYII="/></svg>'
    )
  // 注册一个工具栏按钮名称
  editor.ui.registry.addButton("watermark", {
    icon: "watermark",
    tooltip: pluginName,
    onAction: function() {
      openDialog()
    }
  })

  // 注册一个菜单项名称
  editor.ui.registry.addMenuItem("watermark", {
    text: "水印",
    icon: "watermark",
    onAction: function() {
      openDialog()
    }
  })

  return {
    getMetadata: function() {
      return {
        // 插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
        name: "watermark", // 插件名称
        url: "" // 作者网址
      }
    }
  }
})
